module.exports = __webpack_public_path__ + "img/welcome-dark.1aee5929.svg";